import { Component, OnInit } from '@angular/core';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent implements OnInit {

  constructor(private utilService: UtilitieService) { }

  ngOnInit(): void {
    this.utilService.updateLoading(false);
  }

}
